import { FC, ReactNode } from 'react'

/** Card wrapper giving each Methodology Report section a consistent heading + body. */
const Section: FC<{ title: string; subtitle?: string; children: ReactNode }> = ({
  title,
  subtitle,
  children
}) => (
  <section className="border border-gray-200 dark:border-neutral-70 rounded-lg bg-white dark:bg-neutral-80 overflow-hidden">
    <header className="px-4 py-2 border-b border-gray-200 dark:border-neutral-70">
      <h3 className="text-sm font-bold text-gm-blue">{title}</h3>
      {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
    </header>
    <div className="p-4">{children}</div>
  </section>
)

/** Shared empty state shown until baseline/proposed run selection is wired. */
export const SectionEmpty: FC<{ message?: string }> = ({ message }) => (
  <div className="text-xs text-gray-400 italic py-6 text-center">
    {message ?? 'Select a baseline and proposed methodology to populate this section.'}
  </div>
)

export default Section
